module.exports = __webpack_public_path__ + "img/red-card.254b676f.svg";